import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	headerCaption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	adminHeaderCaption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headerCaptionGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	adminHeaderCaptionGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	headerCaption: {
		id: 'projects-directory-v3.page-layout.header.header-caption',
		defaultMessage: 'Projects',
		description: 'Page title for Projects Directory page',
	},
	adminHeaderCaption: {
		id: 'projects-directory-v3.page-layout.header.admin-header-caption',
		defaultMessage: 'Manage Projects',
		description: 'Page title for Admin Projects Directory page',
	},
	headerCaptionGalaxia: {
		id: 'projects-directory-v3.page-layout.header.header-caption-galaxia',
		defaultMessage: 'Spaces',
		description: 'Page title for Projects Directory page',
	},
	adminHeaderCaptionGalaxia: {
		id: 'projects-directory-v3.page-layout.header.admin-header-caption-galaxia',
		defaultMessage: 'Manage Spaces',
		description: 'Page title for Admin Projects Directory page',
	},
});
export default messages;
